import React, { useEffect, useRef } from 'react';
import ClipboardJS from 'clipboard';

const CopyToClipboardButton = ({ setTextToCopy, className, closeMenu }) => {
    const buttonRef = useRef(null);

    useEffect(() => {
        // Инициализация ClipboardJS при монтировании компонента
        if (!buttonRef.current) return;
        // const hasPhoneAccess = accessor.clientPhone(user);
        // const clipboard = new ClipboardJS(buttonRef.current, {
        //     text: () => hasPhoneAccess && window.confirm('Скрыть номер телефона') ? textToCopy : '4ebureeek))',
        // });
        const clipboard = new ClipboardJS(buttonRef.current, {
            text: () => setTextToCopy()
        });

        // Обработчик успешного копирования
        clipboard.on('success', (e) => {
            // Выполните дополнительные действия при успешном копировании, если необходимо
        });

        // Обработчик ошибки копирования
        clipboard.on('error', (e) => {
            console.error('Ошибка копирования:', e.action);
            // Обработка ошибки копирования, если необходимо
        });

        // Очистка ClipboardJS при размонтировании компонента
        return () => {
            clipboard.destroy();
        };
    }, [setTextToCopy]);

    return (
        <div className={className} ref={buttonRef} onClick={closeMenu}>
            Копировать
        </div>
    );
};

export default CopyToClipboardButton;
